<template>
	<div class="xhorse-home">
		<x-header :path="$path"
				  :backColor="backColor"
				  :textColor="textColor"
				  :activeTopIndex="activeIndex.top"
				  :activeSideIndex="activeIndex.side"
				  @go="activeTo"></x-header>
		<div class="banner-area" :style="aboutBannerStyle">
			<div class="banner-con" :style="aboutBannerStyle">
				<img :src="source.banner" alt="Xhorse" :style="aboutBannerStyle"/>
			</div>
		</div>
		<div class="belong-area" :class="belongClass">
			<div class="belong-con" :class="belongClass">
				<div class="top-bar" :style="topBar">
					<div class="bread-con">
						<div class="txt">
							Home/	{{ getTopBarTitle }}
						</div>
					</div>
				</div>
				<div class="item-con" :class="[activeClass]">
					<div ref="aboutSide" class="x-flow side side-bg-color z-index-lower"
						 :style="{minWidth : aboutSideStyle.minWidth}"
						 :class="[activeClass]">
						<x-side :activeSideIndex="activeIndex.side"
								:activeTopIndex="activeIndex.top"
								:aboutSideStyle="aboutSideStyle"
								:activeClass="activeClass"
								@go="activeTo"></x-side>
					</div>
					<div class="x-flow body main-bg-color z-index-upper"
						 :class="[activeClass]" :style="aboutMainStyle">
						<x-main ref="aboutMain" :activeSideIndex="activeIndex.side"
								:activeTopIndex="activeIndex.top"
								@go="activeTo"></x-main>
					</div>
				</div>
			</div>
		</div>
		<x-footer></x-footer>
		<x-home :backVisible="backVisible" :backStyle="backStyle"></x-home>
	</div>
</template>

<script>
    import xHeader from '@/components/zh-cn/header.vue'
    import xSide from '@/components/zh-cn/side.vue'
    import xMain from '@/components/zh-cn/main.vue'

    import solution_banner_01 from '@/assets/resource/images/solution/banner_solutions_key.png'
    import solution_banner_02 from '@/assets/resource/images/solution/banner_solutions_professional.png'
    import solution_banner_03 from '@/assets/resource/images/solution/banner_solutions_ic.png'
    import solution_banner_04 from '@/assets/resource/images/solution/banner_solutions_access.png'
    import solution_banner_05 from '@/assets/resource/images/solution/banner_solutions_hpc.png'
    import solution_banner_06 from '@/assets/resource/images/solution/banner_solutions_customization.png'
    import solution_banner_07 from '@/assets/resource/images/solution/banner_solutions_precision.png'
    import solution_banner_08 from '@/assets/resource/images/solution/banner_solutions_servo.png'
    import solution_banner_09 from '@/assets/resource/images/solution/banner_solutions_optics.png'
    import solution_banner_10 from '@/assets/resource/images/solution/banner_solutions_ime.png'
    //import solution_banner_11 from '@/assets/resource/images/solution/banner_solutions_intellgent.png'
    import solution_banner_11 from '@/assets/resource/images/solution/banner_solutions_system.png'
    //import solution_banner_12 from '@/assets/resource/images/solution/banner_solutions_web.png'
    import solution_banner_12 from '@/assets/resource/images/solution/banner_solutions_intelligent.png'
    import solution_banner_13 from '@/assets/resource/images/solution/banner_solutions_web.png'
    import coreLib from '@/lib/common'
    export default {
        components: {
            xFooter: () => import('@/components/zh-cn/footer'),
            xHome: () => import('@/components/zh-cn/home'),
            xHeader: xHeader,
            xSide: xSide,
            xMain: xMain
        },
        data: function () {
            return {
                textColor: '#2A2E2E',
                backColor: '#FFFFFF',
                topBar: {
                    height: '3.4375rem'
                },
                source: {
                    banner: solution_banner_01,
                },
                activeIndex: {
                    top: [],
                    side: []
                },
                activeClass: '',
                belongClass: '',
                aboutBannerStyle: {},
                aboutSideStyle: {},
                aboutMainStyle: {},
                backVisible: false,
                backStyle: {
                    bottom: '3rem'
                }
            };
        },
        methods: {
            activeTo(params){
                //console.log("Template[solution]: ", params)
                const _this = this;
                const componentInfo = _this.$RegistedName;
                const dateTime = (new Date()).getTime();
                var sideVal = [];
                if (params.type == 'top') {
                    var fullPath = params.val.map((item) => {
                        if (toString(item).indexOf('-')) {
                            return parseInt(item.toString().split('-').reverse()[0]);
                        } else {
                            return parseInt(item);
                        }
                    });
                    _this.activeIndex.top = fullPath;
                    _this.activeIndex.side = fullPath.slice(-1);
                    sideVal = _this.activeIndex.side;
                    _this.$router.push({name: componentInfo[fullPath[0]].componentName, params: {date: dateTime}})
                } else {
                    _this.activeIndex.side = params.val;
                    sideVal = params.val;
                }
                window.scrollTo(0, 0);
            },
            getMainPageHeight(activeInfo) {
                const _this = this;
                var activeTop = activeInfo.top;
                var activeSide = activeInfo.side;
                var assem = [activeTop[0], activeTop[1], activeSide[0]];
                switch (assem.join(',')) {
                    case "2,1,1":
                        _this.activeClass = 'solution-key-cutting-class';
                        _this.belongClass = 'belong-area-for-key-cutting-class';
                        break;
                    case "2,2,1":
                    case "2,2,2":
                        _this.activeClass = 'solution-vvdi-univeral-class';
                        _this.belongClass = 'belong-area-for-vvdi-univeral-class';
                        break;
                    case "2,3,3":
                        _this.activeClass = 'solution-ic-programmer-class';
                        _this.belongClass = 'belong-area-for-ic-programmer-class';
                        break;
                    case "2,4,4":
                    case "2,4,1":
                        _this.activeClass = 'solution-access-class';
                        _this.belongClass = 'belong-area-for-access-class';
                        break;
                    case "2,5,5":
                    case "2,5,1":
                        _this.activeClass = 'solution-hpc-class';
                        _this.belongClass = 'belong-area-for-hpc-class';
                        break;
                    case "2,6,6":
                    case "2,6,1":
                        _this.activeClass = 'solution-asic-team-class';
                        _this.belongClass = 'belong-area-for-asic-team-class';
                        break;
                    case "2,7,1":
                        _this.activeClass = 'solution-desktop-engraving-class';
                        _this.belongClass = 'belong-area-for-desktop-engraving-class';
                        break;
                    case "2,7,2":
                        _this.activeClass = 'solution-tools-sharpner-class';
                        _this.belongClass = 'belong-area-for-tools-sharpner-class';
                        break;
                    case "2,7,3":
                        _this.activeClass = 'solution-dental-carving-class';
                        _this.belongClass = 'belong-area-for-dental-carving-class';
                        break;
                    case "2,7,4":
                        _this.activeClass = 'solution-robotic-arm-class';
                        _this.belongClass = 'belong-area-for-robotic-arm-class';
                        break;
                    case "2,7,5":
                        _this.activeClass = 'solution-axis-platform-class';
                        _this.belongClass = 'belong-area-for-axis-platform-class';
                        break;
                    case "2,7,6":
                        _this.activeClass = 'solution-servo-system-class';
                        _this.belongClass = 'belong-area-for-servo-system-class';
                        break;
                    case "2,8,8":
                    case "2,8,1":
                        _this.activeClass = 'solution-servo-system-class';
                        _this.belongClass = 'belong-area-for-servo-system-class';
                        break;
                    case "2,9,1":
                        _this.activeClass = 'solution-3d-scanner-class';
                        _this.belongClass = 'belong-area-for-3d-scanner-class';
                        break;
                    case "2,9,2":
                        _this.activeClass = 'solution-plane-intruction-class';
                        _this.belongClass = 'belong-area-for-plane-intruction-class';
                        break;
                    case "2,9,3":
                        _this.activeClass = 'solution-tool-software-class';
                        _this.belongClass = 'belong-area-for-tool-software-class';
                        break;
                    case "2,9,4":
                        _this.activeClass = 'solution-optical-key-class';
                        _this.belongClass = 'belong-area-for-optical-key-class';
                        break;
                    case "2,9,5":
                        _this.activeClass = 'solution-three-dimensional-class';
                        _this.belongClass = 'belong-area-for-three-dimensional-class';
                        break;
                    case "2,9,6":
                        _this.activeClass = 'solution-binocular-vision-class';
                        _this.belongClass = 'belong-area-for-binocular-vision-class';
                        break;
                    case "2,9,7":
                        _this.activeClass = 'solution-intelligent-object-class';
                        _this.belongClass = 'belong-area-for-intelligent-object-class';
                        break;
                    case "2,10,1":
                        _this.activeClass = 'solution-intelligent-cnc-class';
                        _this.belongClass = 'belong-area-for-intelligent-cnc-class';
                        break;
                    case "2,10,2":
                        _this.activeClass = 'solution-untral-technology-class';
                        _this.belongClass = 'belong-area-for-untral-technology-class';
                        break;
                    case "2,10,3":
                        _this.activeClass = 'solution-automatic-complete-class';
                        _this.belongClass = 'belong-area-for-automatic-complete-class';
                        break;
                    case "2,10,4":
                        _this.activeClass = 'solution-overall-equipment-class';
                        _this.belongClass = 'belong-area-for-overall-equipment-class';
                        break;
                    case "2,11,11":
                    case "2,11,1":
                        _this.activeClass = 'solution-system-level-maching-class';
                        _this.belongClass = 'belong-area-for-system-level-maching-class';
                        break;
                    case "2,12,1":
                        _this.activeClass = 'solution-manufacturing-execution-class';
                        _this.belongClass = 'belong-area-for-manufacturing-execution-class';
                        break;
                    case "2,12,2":
                        _this.activeClass = 'solution-intelligent-equipment-class';
                        _this.belongClass = 'belong-area-for-intelligent-equipment-class';
                        break;
                    case "2,12,3":
                        _this.activeClass = 'solution-fast-dashboard-class';
                        _this.belongClass = 'belong-area-for-fast-dashboard-class';
                        break;
                    case "2,13,13":
                    case "2,13,1":
                        _this.activeClass = 'solution-web-services-internet-class';
                        _this.belongClass = 'belong-area-for-web-services-internet-class';
                        break;
                    default:
                        _this.activeClass = 'solution-developing-modules-class';
                        _this.belongClass = 'belong-area-for-developing-modules-class';
                        break;
                }
            },
            onAboutScroll(){
                const _this = this;
                const aboutSide = _this.$refs.aboutSide;
                const viewWidth = window.screen.availWidth;
				/*console.log("solution: ", aboutSide.getBoundingClientRect())*/
                try {
                    // 元素相对于浏览器的位置TOP
                    if (aboutSide.offsetTop >= 0) {
                        const SidePos = aboutSide.offsetTop;
                        //console.log("Menu[offsetTop]", SidePos)
                        // 元素相对于视窗的位置TOP
                        const SideClient = aboutSide.getBoundingClientRect();
                        const xheader = document.getElementById('x-header').getBoundingClientRect();
                        const xfooter = document.getElementById('x-wrap-footer').getBoundingClientRect();
                        const viewHeight = window.screen.availHeight;
                        const viewWidth = window.screen.availWidth;
						/*console.log("solution: ", SideClient)*/
                        if (SideClient.top < 0) {
                            _this.aboutSideStyle = {
                                position: 'fixed',
                                height: '100%',
                                background: 'none',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0
                            };
                        } else {
                            _this.aboutSideStyle.position = '';
                        }
                        if (xheader.top < _this.$visibleHomeTop) {
                            _this.backVisible = true;
                            if ((xfooter.top / 16) <= (viewHeight / 16)) {
                                const realBottomEm =
                                ((viewHeight - xfooter.top) / 16) < 30 ?
                                (30 + 0.8125 + 'rem') : (((viewHeight - xfooter.top) / 16) + 0.8125 + 'rem');
                                const realBottomPx = (viewHeight - xfooter.top) + 'px';
                                _this.backStyle.bottom = viewWidth > 1280 ? realBottomPx : realBottomEm;
                            } else {
                                _this.backStyle.bottom = '3rem';
                            }
                        } else {
                            _this.backVisible = false;
                        }
                    }
                } catch (err) {
                    //console.log(err)
                }

            }
        },
        computed: {
            getTopBarTitle: function () {
                const _this = this;
                const activeTop = _this.activeIndex.top;
                var activeTitle = '';
                switch (parseInt(activeTop[1])) {
                    case 1:
                        activeTitle = 'Key Cutting Machine Solutions';
                        break;
                    case 2:
                        activeTitle = 'Professional Automotive Tools';
                        break;
                    case 3:
                        activeTitle = 'IC Programmers Solutions';
                        break;
                    case 4:
                        activeTitle = 'Access Solutions';
                        break;
                    case 5:
                        activeTitle = 'HPC Solutions';
                        break;
                    case 6:
                        activeTitle = 'Customization ASIC Solutions';
                        break;
                    case 7:
                        activeTitle = 'Precision Machinery & Motion Control Solutions';
                        break;
                    case 8:
                        activeTitle = 'Servo System Solutions';
                        break;
                    case 9:
                        activeTitle = 'Optics Measurement & Image Recognition Solutions';
                        break;
                    case 10:
                        activeTitle = 'IME Intelligent Mechanical Equipment Solutions';
                        break;
                    case 11:
                        activeTitle = 'System Level Machining Accuracy Assurance Solution';
                        break;
                    case 12:
                        activeTitle = 'Intelligent Process Control Solution';
                        break;
                    case 13:
                        activeTitle = 'Web Services - Industrial Internet of Things Solution';
                        break;
                }
                return activeTitle;
            }
        },
        mounted(){
            const _this = this;
            const isMobile = coreLib._isMobile();
            const activePath = _this.$store.state;
            if (activePath.activeTop.length > 0 && activePath.activeSide.length > 0) {
                _this.activeIndex.top = activePath.activeTop;
                _this.activeIndex.side = activePath.activeSide;
            } else {
                _this.activeIndex.top = [2, 1, 0];
                _this.activeIndex.side = [1];
            }

            $("#x-header .h-li").css({color: '#2A2E2E'})
            // 监听滚动事件
            window.addEventListener('scroll', _this.onAboutScroll);
            const screenWh = document.body.clientWidth;
            /*_this.aboutBannerStyle['minHeight'] = ((parseInt(screenWh) * 482) / 1920 / 16) + 'rem';*/
        },
        destroyed() {
            const _this = this;
            window.removeEventListener('scroll', _this.onAboutScroll, false);
        },
        watch: {
            'activeIndex.top': function (val) {
                const _this = this;

            },
            activeIndex: {
                handler(activeInfo){
                    const _this = this;
                    _this.getMainPageHeight(activeInfo);
                    switch (parseInt(activeInfo.top[1])) {
                        case 1:
                            _this.source.banner = solution_banner_01;
                            break;
                        case 2:
                            _this.source.banner = solution_banner_02;
                            break;
                        case 3:
                            _this.source.banner = solution_banner_03;
                            break;
                        case 4:
                            _this.source.banner = solution_banner_04;
                            break;
                        case 5:
                            _this.source.banner = solution_banner_05;
                            break;
                        case 6:
                            _this.source.banner = solution_banner_06;
                            break;
                        case 7:
                            _this.source.banner = solution_banner_07;
                            break;
                        case 8:
                            _this.source.banner = solution_banner_08;
                            break;
                        case 9:
                            _this.source.banner = solution_banner_09;
                            break;
                        case 10:
                            _this.source.banner = solution_banner_10;
                            break;
                        case 11:
                            _this.source.banner = solution_banner_11;
                            break;
                        case 12:
                            _this.source.banner = solution_banner_12;
                            break;
                        case 13:
                            _this.source.banner = solution_banner_13;
                            break;

                    }
                    //console.log("监听：", activeInfo)
                },
                deep: true
            }
        },
        beforeRouteLeave (to, from, next) {
                 if(['/software','/xhorseIM','/download'].includes(to.path)){
                next(true)
                return
             }
            const _this = this;
            var data = {
                side: _this.activeIndex.side,
                top: _this.activeIndex.top,
            };

            if (to.params.hasOwnProperty('activeTop') && to.params.hasOwnProperty('activeSide')) {
                data.side = to.params.activeSide;
                data.top = to.params.activeTop;
            }

            _this.$store.commit('setActivePath', {
                type: 'all',
                val: data
            });
            window.removeEventListener('scroll', _this.onAboutScroll);
            next(true)
        }
    }

</script>

<style scoped>

	@import "../../assets/css/solution.css";

</style>



// WEBPACK FOOTER //
// src/components/zh-cn/solution.vue